import * as Effects from 'redux-saga/effects'
import closeModal from '../../actions/Modals/closeModal'
import { toggleTemplateSendModalLoading } from '../../actions/templates/templateSendModal'
import fireToastError from '../../actions/toasts/fireToastError'
import { Modals } from '../../containers/Modals/ModalContainer'
import i18n from '../../i18n'
import { loadTemplates } from '../templates/loadTemplates'

export default function*() {
  yield Effects.put(toggleTemplateSendModalLoading(true))
  const results = yield Effects.call(loadTemplates)
  if (results === undefined) {
    yield Effects.put(closeModal(Modals.TemplateSendModal))
    yield Effects.put(fireToastError(i18n.t('errStatus_999')))
  }
}
